import { LayerOrientation } from "@buildwithflux/models";
import { extractShapes } from "./support/customSilkShapes";
import { getModule, getRotatedPosition, toMm } from "./support/utils";
export const mapLine = (line, context, postprocess) => {
    const br = line.bakedRules;
    if (!br) {
        return null;
    }
    const scale = br.scale.x;
    if (br.asset || br.linePath) {
        // TODO: scale ??
        const { polyShapes, lineShapes } = extractShapes(br);
        postprocess((mapped) => {
            if (!mapped)
                return;
            const module = getModule(br.layer, context);
            if ("pts" in mapped) {
                module.fp_poly = module.fp_poly ?? [];
                module.fp_poly.push(mapped);
            }
            if ("start" in mapped && "end" in mapped) {
                module.fp_line = module.fp_line ?? [];
                module.fp_line.push(mapped);
            }
        });
        return [...polyShapes, ...lineShapes];
    }
    else {
        const startPosition = {
            x: br.startPosition.x * scale,
            y: br.startPosition.y * scale,
            z: br.startPosition.z,
        };
        const endPosition = {
            x: br.endPosition.x * scale,
            y: br.endPosition.y * scale,
            z: br.endPosition.z,
        };
        const start = getRotatedPosition(startPosition, br.rotationRelativeToDocument);
        const end = getRotatedPosition(endPosition, br.rotationRelativeToDocument);
        const position = {
            start: {
                x: toMm(br.positionRelativeToDocument.x + start.x),
                y: -toMm(br.positionRelativeToDocument.y + start.y),
            },
            end: {
                x: toMm(br.positionRelativeToDocument.x + end.x),
                y: -toMm(br.positionRelativeToDocument.y + end.y),
            },
        };
        postprocess((mapped) => {
            if (!mapped)
                return;
            const module = getModule(br.layer, context);
            module.fp_line = module.fp_line ?? [];
            module.fp_line.push(mapped);
        });
        const result = {
            ...position,
            layer: br.layer === LayerOrientation.top ? "F.SilkS" : "B.SilkS",
            width: toMm((br.strokeWidth ?? 0) * scale),
        };
        return result;
    }
};
//# sourceMappingURL=mapLine.js.map